import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_administration/settings/move-in/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/move-in/forms", replace: true });
  },
});
